// Appels HTTP vers l'API des comptes : cookies HttpOnly envoyés automatiquement, en-tête anti-CSRF obligatoire.

/** Lecture : lève une erreur si le serveur répond par un code d'erreur (limite de débit, session absente…). */
export async function apiGet<T = Record<string, unknown>>(path: string): Promise<T> {
  const r = await fetch(path, { credentials: 'same-origin' });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return (await r.json()) as T;
}

export async function apiPost<T = Record<string, unknown>>(path: string, body: unknown = {}): Promise<{ status: number; data: T }> {
  const r = await fetch(path, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', 'x-tankshift': '1' },
    body: JSON.stringify(body),
  });
  let data: T;
  try {
    data = (await r.json()) as T;
  } catch {
    data = {} as T;
  }
  return { status: r.status, data };
}

export interface MeResponse {
  /** `admin` : présent seulement pour un compte admin (le serveur revérifie chaque action). */
  account: { publicId: string; name: string; email: string; verified: boolean; admin?: boolean } | null;
  guest: boolean;
  /** Faux tant qu'aucun e-mail ne peut partir (production sans Brevo). */
  mail?: boolean;
  balances: Record<string, number>;
  pass?: { season: { id: string; name: string; startsAt?: number; endsAt: number }; ended?: boolean; xp: number; level: number; premium: boolean; claimed: string[] };
  missions?: {
    daily: { id: string; label: string; target: number; progress: number; done: boolean }[];
    weekly: { id: string; label: string; target: number; progress: number; done: boolean }[];
    dailyReward: { coins: number; passXp: number };
    weeklyReward: { coins: number; passXp: number };
  };
  roulette?: { used: number; max: number };
  /** Cosmétique équipé sur toutes les classes (null : variantes choisies par classe). */
  equipped?: string | null;
}

/** Saison du calendrier (limites en UTC, fin exclue). */
export interface SeasonInfo {
  id: string;
  name: string;
  startsAt: number;
  endsAt: number;
}

/** Barème du pass, envoyé par le serveur (valeurs par défaut côté client si absent). */
export interface PassConfig {
  xpPerLevel: number;
  maxLevel: number;
  premiumGems: number;
}

/** Réponse de `GET /api/pass[?season=<id>]` : tableau public d'une saison ; champs récents facultatifs. */
export interface PassTableResponse<L = unknown> {
  season?: string;
  levels: L[];
  seasonInfo?: SeasonInfo;
  config?: Partial<PassConfig>;
  next?: SeasonInfo | null;
}
